import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation/navigation.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ListingCounterComponent } from './listing-counter/listing-counter.component';
import { ListingSearchComponent } from './listing-search/listing-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListingFiltersComponent } from './listing-filters/listing-filters.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { TspSelectionComponent } from './tsp-selection/tsp-selection.component';
import { AlertConfirmationComponent } from './alert-confirmation/alert-confirmation.component';
import { SnackbarComponent } from './snackbar/snackbar.component';

@NgModule({
  declarations: [
    NavigationComponent,
    ListingCounterComponent,
    ListingSearchComponent,
    ListingFiltersComponent,
    CountdownTimerComponent,
    FileUploadComponent,
    TspSelectionComponent,
    AlertConfirmationComponent,
    SnackbarComponent
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    NavigationComponent,
    ListingCounterComponent,
    ListingSearchComponent,
    ListingFiltersComponent,
    CountdownTimerComponent,
    FileUploadComponent,
    SnackbarComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UtilityModule { }
